module.exports = __webpack_public_path__ + "img/Vintage-Frame.9f5dac9b.jpg";